import { SeoModel } from '../../models';

export type HeadOpenGraphMetaModel = {
  seo?: SeoModel;
};

export enum MetaOpenGraphTags {
  title = 'og:title',
  description = 'og:description',
  type = 'og:type',
  url = 'og:url',
  image = 'og:image',
  site = 'og:site_name',
}
